import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Form as DXForm} from 'devextreme-react/form';


export default class Form extends Component {
    // constructor(props) {
    //     super(props);
    //
    //     this.state = {
    //         visible: this.props.visible,
    //     };
    //
    //     this.onShowing = this.onShowing.bind(this);
    //     this.onHiding = this.onHiding.bind(this);
    //
    //     this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
    // }

    // UNSAFE_componentWillReceiveProps(props) {
    //     this.setState({
    //         visible: props.visible,
    //     });
    // }
    //
    // closeOnOutsideClick(e) {
    //     e;
    //     this.setState({visible: false});
    //     return true;
    // }
    //
    // onShowing(e) {
    //     this.setState({visible: true});
    // }
    //
    // onHiding(e) {
    //     this.setState({visible: false});
    // }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return <DXForm
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
            {...dataAttributes}
        >
            {this.props.children}
        </DXForm>
    }
}

Form.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Specifies whether or not all root item labels are aligned
     */
    alignItemLabels: PropTypes.bool,
    /**
     * Specifies whether or not item labels in all groups are aligned
     */
    alignItemLabelsInAllGroups: PropTypes.bool,
    /**
     * The count of columns in the form layout
     */
    colCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * Specifies dependency between the screen factor and the count of columns in the form layout
     */
    colCountByScreen: PropTypes.object,
    /**
     * Specifies a function that customizes a form item after it has been created
     */
    customizeItem: PropTypes.func,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Provides the Form's data. Gets updated every time form fields change
     */
    formData: PropTypes.object,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Holds an array of form items
     */
    items: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies the location of a label against the editor
     */
    labelLocation: PropTypes.oneOf(['left', 'right', 'top']),
    /**
     * The minimum column width used for calculating column count in the form layout
     */
    minColWidth: PropTypes.number,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed when the Enter key has been pressed while an editor is focused
     */
    onEditorEnterKey: PropTypes.func,
    /**
     * A function that is executed when the value of a formData object field is changed
     */
    onFieldDataChanged: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * The text displayed for optional fields
     */
    optionalMark: PropTypes.string,
    /**
     * Specifies whether all editors on the form are read-only. Applies only to non-templated items
     */
    readOnly: PropTypes.bool,
    /**
     * The text displayed for required fields
     */
    requiredMark: PropTypes.string,
    /**
     * Specifies the message that is shown for end-users if a required field value is not specified
     */
    requiredMessage: PropTypes.string,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies a function that categorizes screens by their width
     */
    screenByWidth: PropTypes.func,
    /**
     * A Boolean value specifying whether to enable or disable form scrolling
     */
    scrollingEnabled: PropTypes.bool,
    /**
     * Specifies whether or not a colon is displayed at the end of form labels
     */
    showColonAfterLabel: PropTypes.bool,
    /**
     * Specifies whether or not the optional mark is displayed for optional fields
     */
    showOptionalMark: PropTypes.bool,
    /**
     * Specifies whether or not the required mark is displayed for required fields
     */
    showRequiredMark: PropTypes.bool,
    /**
     * Specifies whether or not the total validation summary is displayed on the form
     */
    showValidationSummary: PropTypes.bool,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Gives a name to the internal validation group
     */
    validationGroup: PropTypes.string,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Form.defaultProps = {
    accessKey: null,
    activeStateEnabled: false,
    alignItemLabels: true,
    alignItemLabelsInAllGroups: true,
    colCount: 1,
    // colCountByScreen: undefined,
    customizeItem: null,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: false,
    formData: {},
    height: 'auto',
    // hint: undefined,
    hoverStateEnabled: false,
    // items: undefined,
    labelLocation: 'left', // 'top' (Material)
    minColWidth: 200,
    onContentReady: null,
    onDisposing: null,
    onEditorEnterKey: null,
    onFieldDataChanged: null,
    onInitialized: null,
    onOptionChanged: null,
    optionalMark: 'optional',
    readOnly: false,
    requiredMark: '*',
    requiredMessage: '{0} is required',
    rtlEnabled: false,
    screenByWidth: null,
    scrollingEnabled: false,
    showColonAfterLabel: true, // false (Material)
    showOptionalMark: false,
    showRequiredMark: true,
    showValidationSummary: false,
    tabIndex: 0,
    // validationGroup: undefined,
    visible: true,
    width: 'auto'
};
